import React, { Component } from 'react';
import Questions from './components/Questions';
import QuizDescription from './QuizDescription';
import QuizResults from './QuizResults';
import { ProgressBar } from 'react-bootstrap';
import config from './config';
import data from './Data/data.json';
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quiz: {},
            activeView: null,
            totalQ: 0,
            currentQuestionIndex: 0,
            answers: [],
            uid: null,
            time: 5,
            endQuiz: false,
            endQuizMsg: ''
        };

        this.submitAnswer = this.submitAnswer.bind(this);
    }

    componentDidMount() {
        this.setState({quiz: this.getData()});
        this.showQuizDescription();
    };

    getData() {
        // let quizProp = `${window.location.pathname}`.replace(/[^a-zA-Z ]/g, '');
        const queryString = window.location.search;
        console.log(queryString);
        const urlParams = (queryString)?new URLSearchParams(queryString):null;

        let uid = (urlParams) ? urlParams.get('uid') : null;
        if (!uid) {
            uid = (new Date().getTime() / 1000).toFixed(0);
        }
        const quizProp = (urlParams)?urlParams.get('q'):null;
        console.log('[USER_ID]', uid);

        if(uid && quizProp){
            try{
                const quizFile = data;//require('./Data/data.json');
                const quiz = (quizFile && quizFile[quizProp])?quizFile[quizProp]:{};

                // Add Id's
                quiz.questions.forEach((q, idx) => {
                    if(!q.id){
                        q.id = `${idx+1}`;
                    }
                });

                // quiz.questions = questions;
                if(quiz.questions){
                    this.setState({totalQ: (quiz.questions.length), uid: uid});
                }
                if(quiz.browserTitle){
                    document.title = quiz.browserTitle;
                }

                return quiz;
            } catch(err){
                console.error(err);
                return {};
            }
        } else {
            return {};
        }
    };

    showQuizDescription() {
        this.setState((prevState, props) => {
            return {
                activeView: 'quizOverview'
            };
        });
    }
    
    showQuizQuestion(index) {
        console.log('Question: ', index);
        this.setState((prevState) => {
            return {
                currentQuestionIndex: index,
                activeView: 'quizQuestions',
                buttonsDisabled: false,
                transitionDelay: 1000
            };
        });
    };
    
    showResults() {
        this.setState((prevState) => {
            return {
                activeView: 'quizResults'
            };
        });
    }

    submitAnswer(answer, t = 'n') {
        var app = this;

        // save answer and disable button clicks
        if(t === 'n'){
            this.setState((prevState) => {
                return {
                    buttonsDisabled: true,
                    answers: (answer)?Object.assign({ [this.state.currentQuestionIndex]: answer }, prevState.answers):0
                };
            });
        }

        // Check for Kill Call
        let question = app.state.quiz.questions[app.state.currentQuestionIndex];
        if(question.kill && answer && answer.value && question.kill === answer.value){
            this.setState({endQuiz: true, endQuizMsg: question.killMsg || ''});
            setInterval(() => {
                let {time} = app.state;
                if(time <= 0){
                    window.location = `${app.state.uid}`.length > 5 ? `${app.state.quiz.redirectRegister}/${app.state.uid}` : app.state.quiz.redirect;
                } else {
                    app.setState({time: time-1});
                }
            }, 1000);
        }

        // pause for question result to show before callback
        window.setTimeout(function () {

            // determine if there are any other questions to show or show results
            let nextIndex = app.state.currentQuestionIndex + 1,
                hasMoreQuestions = (nextIndex < app.state.quiz.questions.length);

            (hasMoreQuestions) ? app.showQuizQuestion(nextIndex) : app.showResults();
            
        }, this.state.transitionDelay);
    };
    
    getResults() {
        let res = this.state.quiz.questions.map((item, index) => {
            return Object.assign({}, item, this.state.answers[index]);
        });
        // console.log('[results]', res);
        return res;
    };

    render() {
        let { currentQuestionIndex, totalQ, uid, endQuiz, endQuizMsg } = this.state;
        let perc = (((currentQuestionIndex)/(totalQ || 1))*100).toFixed(0);

        if(endQuiz){
            return <div className="App">
                <h2>{endQuizMsg || 'Thank you for your answer. Please contact your nearest therapist or counsellor in your area, or speak to a parent or guardian. '}</h2>
                <br/><br/>
                <a className='redirectBtn' onClick={() => window.location = config.login} >Home</a>
            </div>;
        }

        if (uid === null || uid === undefined) {
            const loginUrl = config.login;
            const hasLoginUrl = loginUrl !== undefined && loginUrl !== null && loginUrl !== '';

            return (
                <div className="App App--loginRequired">
                    <section className="loginGate" aria-labelledby="login-gate-title">
                        <header className="loginGate-header">
                            <img
                                className="loginGate-logo"
                                src={`${process.env.PUBLIC_URL}/dynamic-health-logo.avif`}
                                alt="Dynamic Health"
                            />
                        </header>
                        <div className="loginGate-body">
                            <h2 id="login-gate-title" className="loginGate-title">
                                Please log in before attempting a quiz
                            </h2>
                            <p className="loginGate-copy">
                                You need to be signed in to start this assessment.
                            </p>
                            {hasLoginUrl ? (
                                <a className="loginGate-button" href={loginUrl}>
                                    Login
                                </a>
                            ) : null}
                        </div>
                    </section>
                </div>
            );
        }

        return (
            <div className="App">
                <div className={`App-header${this.state.activeView === 'quizOverview' ? ' App-header--overview' : ''}`}>
                    <h2 className="overviewTitle">
                        {this.state.quiz.title}
                    </h2>
                    <br/>
                    {(this.state.activeView === 'quizQuestions')?
                    <div className="App-progressRow">
                        <ProgressBar now={perc} />
                        <div className="App-progressLabelRow">
                            <span className="App-progressLabel">
                                Question {currentQuestionIndex + 1} / {totalQ}
                            </span>
                        </div>
                    </div>:null}
                </div>
                
                {this.state.activeView === 'quizOverview' &&
                    <QuizDescription
                        quiz={this.state.quiz}
                        showQuizQuestion={this.showQuizQuestion.bind(this, 0)}
                    />
                }
                {this.state.activeView === 'quizQuestions' &&
                    <Questions
                        submitAnswer={this.submitAnswer}
                        quiz={this.state.quiz}
                        answers={this.state.answers}
                        currentQuestionIndex={this.state.currentQuestionIndex}
                        buttonsDisabled={this.state.buttonsDisabled}
                        transitionDelay={this.state.transitionDelay}
                    />
                }
                {this.state.activeView === 'quizResults' &&
                    <QuizResults
                        userId={uid}
                        quiz={this.state.quiz}
                        results={this.getResults()}
                        redirect={`${this.state.uid}`.length > 5 ? `${this.state.quiz.redirectRegister}/${this.state.uid}` : this.state.quiz.redirect}
                    />
                }
            </div>
        );
    };

}

export default App;